import { render } from "./MarketplaceView.vue?vue&type=template&id=001a6d06"
import script from "./MarketplaceView.vue?vue&type=script&lang=js"
export * from "./MarketplaceView.vue?vue&type=script&lang=js"

import "./MarketplaceView.vue?vue&type=style&index=0&id=001a6d06&lang=scss"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__